// Material UI
import { makeStyles } from '@material-ui/core'

export default makeStyles({
  root: {
    margin: 'auto 0',
  },
  input: {
    height: '1.25rem',
    marginLeft: '0.5rem',
  },
  adornedStart: {
    height: '100%',
    borderRadius: '0.5rem',
    border: '1px solid #cdcdce',
  },
})
